<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="pricelist_name" [ttModel]="edit.pricelist_name" ttReadonly></tt-input>
        <tt-input ttLabel="company_name" [ttModel]="edit.company_name" ttReadonly></tt-input>
        <tt-checkbox ttLabel="access_ok" [(ttModel)]="edit.access_ok"></tt-checkbox>
        <tt-checkbox ttLabel="modify_ok" [(ttModel)]="edit.modify_ok"></tt-checkbox>
        <tt-button-save ttText="save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>
